<app-menu-vertical *ngIf="appState === 'operational'">
  <div menu-vertical-section>
    <ng-container *ngFor="let item of userDetail">
      <a menu-vertical-item class="submenu__link" [routerLink]="item.link | localize">{{ item.text | translate }}</a>
    </ng-container>
  </div>
</app-menu-vertical>
